import ApiService from "./api.service";
import JwtService from "./jwt.service";

import { SELECT_FISCAL_YEAR } from "../store/client.module";
import { LOGIN, LOGOUT, UPDATE_USER } from "../store/user.module";

import { SELECT_CLIENT } from "../store/client.module";
import { SELECT_MOR_STORE } from "../store/morStore.module";
import {
  SECURITY_ANSWER_COUNT,
  SELECT_AVAILABLE_PARTICIPANTS,
  SELECT_PARTICIPANT,
  START_IMPERSONATE,
  STOP_IMPERSONATE,
  UNSELECT_AVAILABLE_PARTICIPANTS,
  UNSELECT_PARTICIPANT
} from "../store/participant.module";
import { SELECT_PROGRAM } from "../store/program.module";
import { SELECT_PROGRAM_GROUP } from "../store/programGroup.module";
import { UNSELECT_AVAILABLE_STORE_PROGRAMS, UNSELECT_STORE_PROGRAM } from "../store/storeProgram.module";

const AuthService = {
  store: null,
  init(opts) {
    if (opts.store) {
      this.store = opts.store;
    }
  },
  updateMorStore(overrides = {}) {
    const store = this.store;
    const getters = store && store.getters ? store.getters : null;

    const selectedMorStoreId = getters && getters.selectedMorStore ? getters.selectedMorStore.id : null;

    const morStoreId = overrides.morStoreId != null ? overrides.morStoreId : selectedMorStoreId;

    const payload = {};
    if (morStoreId != null) payload.morStoreId = morStoreId;

    if (Object.keys(payload).length === 0) {
      return Promise.resolve(null);
    }

    return ApiService.post("/auth/update/morStore", payload)
      .then(({ data: updateData }) => {
        if (updateData && updateData.accessTokenExpiresAt) {
          JwtService.storeExpiresAt(updateData.accessTokenExpiresAt);
        }
        return ApiService.get("/auth/me").then(({ data: meData }) => {
          const user = meData && meData.user ? meData.user : meData;
          return this.store.dispatch(UPDATE_USER, user).then(() => updateData);
        });
      })
      .catch(e => {
        console.log(e);
        return Promise.reject("Unable to update auth claims");
      });
  },
  updateParticipant(overrides = {}) {
    const store = this.store;
    const getters = store && store.getters ? store.getters : null;

    const selectedParticipantId = getters && getters.selectedParticipant ? getters.selectedParticipant.id : null;
    const selectedProgramId = getters && getters.selectedProgram ? getters.selectedProgram.id : null;
    const selectedStoreProgramId = getters && getters.selectedStoreProgram ? getters.selectedStoreProgram.id : null;

    const participantId = overrides.participantId != null ? overrides.participantId : selectedParticipantId;
    const programId = overrides.programId != null ? overrides.programId : selectedProgramId;
    const storeProgramId = overrides.storeProgramId != null ? overrides.storeProgramId : selectedStoreProgramId;

    const payload = {};
    if (participantId != null) payload.participantId = participantId;
    if (programId != null) payload.programId = programId;
    if (storeProgramId != null) payload.storeProgramId = storeProgramId;

    if (Object.keys(payload).length === 0) {
      return Promise.resolve(null);
    }

    return ApiService.post("/auth/update/participant", payload)
      .then(({ data: updateData }) => {
        if (updateData && updateData.accessTokenExpiresAt) {
          JwtService.storeExpiresAt(updateData.accessTokenExpiresAt);
        }
        return ApiService.get("/auth/me").then(({ data: meData }) => {
          const user = meData && meData.user ? meData.user : meData;
          return this.store.dispatch(UPDATE_USER, user).then(() => updateData);
        });
      })
      .catch(e => {
        console.log(e);
        return Promise.reject("Unable to update auth claims");
      });
  },
  updateImpersonationParticipant(overrides = {}) {
    const store = this.store;
    const getters = store && store.getters ? store.getters : null;
    const selectedParticipantId = getters && getters.selectedParticipant ? getters.selectedParticipant.id : null;
    const participantId = overrides.participantId != null ? overrides.participantId : selectedParticipantId;
    const payload = {};
    if (participantId != null) payload.participantIdToImpersonate = participantId;

    if (Object.keys(payload).length === 0) {
      return Promise.resolve(null);
    }

    return ApiService.post("/auth/update/impersonate", payload)
      .then(({ data: updateData }) => {
        if (updateData && updateData.accessTokenExpiresAt) {
          JwtService.storeExpiresAt(updateData.accessTokenExpiresAt);
        }
        return ApiService.get("/auth/me").then(({ data: meData }) => {
          const user = meData && meData.user ? meData.user : meData;
          return this.store.dispatch(UPDATE_USER, user).then(() => updateData);
        });
      })
      .catch(e => {
        console.log(e);
        return Promise.reject("Unable to impersonate: " + e.message);
      });
  },
  updateUnimpersonationParticipant() {
    return ApiService.get("/auth/update/unimpersonate")
      .then(({ data: updateData }) => {
        if (updateData && updateData.accessTokenExpiresAt) {
          JwtService.storeExpiresAt(updateData.accessTokenExpiresAt);
        }
        return ApiService.get("/auth/me").then(({ data: meData }) => {
          const user = meData && meData.user ? meData.user : meData;
          return this.store.dispatch(UPDATE_USER, user).then(() => updateData);
        });
      })
      .catch(e => {
        console.log(e);
        return Promise.reject("Unable to unimpersonate: " + e.message);
      });
  },
  login(username, password) {
    return ApiService.post("/auth/login", {
      programGroupKey: ApiService.programGroupKey,
      username: username,
      password: password
    })
      .then(({ data: loginData }) => {
        if (loginData && loginData.accessTokenExpiresAt) {
          JwtService.storeExpiresAt(loginData.accessTokenExpiresAt);
        }
        return ApiService.get("/auth/me");
      })
      .then(({ data }) => {
        const user = data && data.user ? data.user : data;
        return this.store.dispatch(LOGIN, user);
      });
  },
  async logout() {
    const clearLocalSession = async () => {
      await this.store.dispatch(STOP_IMPERSONATE);
      await this.store.dispatch(UNSELECT_PARTICIPANT);
      await this.store.dispatch(UNSELECT_AVAILABLE_PARTICIPANTS);
      await this.store.dispatch(UNSELECT_AVAILABLE_STORE_PROGRAMS, null);
      await this.store.dispatch(UNSELECT_STORE_PROGRAM, null);
      await this.store.dispatch(SELECT_FISCAL_YEAR, null);
      await this.store.dispatch(LOGOUT);
      await JwtService.removeExpiresAt();
      window.localStorage.removeItem("gapp-vuex");
    };

    try {
      await ApiService.post("/auth/logout");
    } catch (error) {
      console.log(error);
    }

    await clearLocalSession();
  },
  verify() {
    /* This verify() method no longer makes API calls to the backend service.  We only care about the JWT expiration date and checking it.  APIs will fail if the JWT token is invalid anyway. */

    // If there is no expiration, then there is no valid session and we should log out just in case.
    if (!JwtService.hasExpiresAt()) {
      return this.logout().then(() => Promise.reject("No session"));
    }
    // If the token is not expired, we're good.
    if (JwtService.verify()) {
      return Promise.resolve();
    }
    // Token is expired — attempt /auth/me which triggers a refresh via the ApiService interceptor.
    // If the refresh token is still valid, a new access token is issued and accessTokenExpiresAt is updated.
    // If the refresh token has also expired, ApiService redirects to /login.
    return ApiService.get("/auth/me")
      .then(({ data }) => {
        const user = data && data.user ? data.user : data;
        return this.store.dispatch(UPDATE_USER, user);
      })
      .catch(() => {
        return this.logout().then(() => Promise.reject("Session expired"));
      });
  },
  isPreEnrolled() {
    let participant = this.store.getters.selectedParticipant;
    return participant && participant.status.name == "PRE";
  },
  storeSecurityAnswerCount() {
    return ApiService.get("/api/securityAnswers/getByUser").then(({ data }) => {
      return this.store.dispatch(SECURITY_ANSWER_COUNT, data.length);
    });
  },
  async storeSelectParticipant(participant) {
    await this.store.dispatch(SELECT_PARTICIPANT, participant);

    if (!participant.program) {
      return Promise.reject("Selected participant with id " + participant.id + " has no program.");
    }

    await this.updateParticipant({
      participantId: participant.id,
      programId: participant.program.id
    });

    await this.storeSelectProgram(participant.program);

    if (participant.program.programGroup && participant.program.programGroup.client) {
      await this.storeSelectClient(participant.program.programGroup.client);
    }

    return this.storeSecurityAnswerCount();
  },
  applyProgramCustomFields(program) {
    return ApiService.get("/api/programs/" + program.id + "/customFields/public").then(({ data }) => {
      program.organizationCustomFields = data.organizationCustomFields;
      program.participantCustomFields = data.participantCustomFields;
      program.promotionCustomFields = data.promotionCustomFields;
      program.promotionTypeCustomFields = data.promotionTypeCustomFields;
      program.saleCustomFields = data.saleCustomFields;
      program.saleProductCustomFields = data.saleProductCustomFields;
      program.claimProductCustomFields = data.claimProductCustomFields;
      program.promotionInvitationCustomFields = data.promotionInvitationCustomFields;
      program.payoutCustomFields = data.payoutCustomFields;
      program.courseCustomFields = data.courseCustomFields;

      return program;
    });
  },
  storeSelectProgram(program, isPublic = false) {
    // Fetch any lazy relationships
    return this.applyProgramCustomFields(program).then(() => {
      return this.store.dispatch(SELECT_PROGRAM, program).then(() => {
        if (!isPublic && program.programType.name == "MOR") {
          return ApiService.get("/api/morStores")
            .then(({ data }) => {
              return this.storeSelectMorStore(data);
            })
            .catch(() => {
              console.log("MOR Store not found");
              // We need to make sure that we are clearing the MOR Store
              return this.storeSelectMorStore(null);
            });
        }
        return Promise.resolve();
      });
    });
  },
  storeSelectMorStore(morStore) {
    return this.store.dispatch(SELECT_MOR_STORE, morStore);
  },
  storeSelectProgramGroup(programGroup) {
    return this.store.dispatch(SELECT_PROGRAM_GROUP, programGroup);
  },
  storeSelectClient(client) {
    return this.store.dispatch(SELECT_CLIENT, client);
  },
  storeAvailableParticipants(user) {
    let promise = ApiService.get("/api/participants/byCurrentUserClientKeyProgramGroupKey?sort=program.name,ASC");
    if (user) {
      promise = ApiService.get(
        "/api/participants/byUserIdClientKeyProgramGroupKey/" + user.id + "?sort=program.name,ASC"
      );
    }
    return promise.then(({ data }) => {
      let participants = data.content
        .filter(participant => participant.status.name != "CAN")
        .filter(participant => participant.program.effective);
      this.store.dispatch(SELECT_AVAILABLE_PARTICIPANTS, participants);
    });
  },
  startImpersonation(participant) {
    return this.store.dispatch(START_IMPERSONATE, participant).then(() => {
      return this.updateImpersonationParticipant({
        participantId: participant.id
      }).then(() => {
        return this.storeSecurityAnswerCount().then(() => {
          return this.storeAvailableParticipants();
        });
      });
    });
  },
  stopImpersonation() {
    if (this.isImpersonating()) {
      this.store.dispatch("startGlobalLoading");
      return this.store
        .dispatch(STOP_IMPERSONATE)
        .then(() => {
          return this.updateUnimpersonationParticipant().then(() => {
            return this.storeAvailableParticipants().then(() => {
              return this.storeSecurityAnswerCount().then(() => {
                return Promise.resolve();
              });
            });
          });
        })
        .finally(() => {
          this.store.dispatch("stopGlobalLoading");
        });
    } else {
      return Promise.resolve();
    }
  },
  isImpersonating() {
    const participant = this.store.getters.impersonationParticipant;
    return participant != null && participant.id != null;
  }
};

export default AuthService;
